import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import {
  ELegitCheckTypeSortField,
  ILegitCheckType,
  PLegitCheckType,
  PLegitCheckTypeFilter,
} from "../entities";
import ILegitCheckTypeRepository from "../repository";

export default class LegitCheckTypeRepository
  implements ILegitCheckTypeRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private LEGIT_CHECK_TYPE_ROUTE = "/admin/legit-check-type";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PLegitCheckTypeFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getLegitCheckType(
    pagination: IPagination,
    filter: PLegitCheckTypeFilter,
    sorts: ISort<ELegitCheckTypeSortField>[],
    signal?: CancelTokenSource
  ): Promise<[ILegitCheckType[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.LEGIT_CHECK_TYPE_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getLegitCheckTypeById(id: number): Promise<ILegitCheckType> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.LEGIT_CHECK_TYPE_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }

  async updateLegitCheckType(
    id: number,
    legitCheckType: PLegitCheckType
  ): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().patch(
        `${this.LEGIT_CHECK_TYPE_ROUTE}/${id}`,
        legitCheckType
      )
    );
    if (err) {
      throw this.getError(err);
    }
  }
}
